/**
 * Tipo para erros de API com response do Axios
 */
export interface ApiError extends Error {
  response?: {
    status: number;
    data?: {
      message?: string;
      [key: string]: unknown;
    };
    statusText?: string;
  };
  request?: unknown;
  config?: unknown;
}

/**
 * Type guard para verificar se um erro é ApiError
 */
export function isApiError(error: unknown): error is ApiError {
  return (
    error instanceof Error &&
    'response' in error &&
    typeof (error as ApiError).response === 'object'
  );
}

/**
 * Type guard para verificar se um erro tem status code específico
 */
export function hasStatusCode(error: unknown, statusCode: number): boolean {
  return isApiError(error) && error.response?.status === statusCode;
}

/**
 * Type guard para verificar se um erro é de autenticação (401 ou 403)
 */
export function isAuthError(error: unknown): boolean {
  return hasStatusCode(error, 401) || hasStatusCode(error, 403);
}

/**
 * Type guard para verificar se um erro é de não encontrado (404)
 */
export function isNotFoundError(error: unknown): boolean {
  return hasStatusCode(error, 404);
}
